import router from "frontend/routes/router"
import urls from "frontend/routes/urls"
import { DEFAULT_VIEW } from "frontend/routes/urls"

export default (name = DEFAULT_VIEW, params = {}) =>
  router.push(urls[name].navigate(params))
